module.exports = __webpack_public_path__ + "static/media/retrohandz_1.6e464cd2.png";